export const SearchPublicRoomDialogTestIds = {
  buttonSearchPublicRoom: 'button_searchpublicroom',
  buttonSearchPublicRoomCollapsed: 'button_search_publicroom_collapsed',
  searchInput: 'public_room_search_input',
  publicRoomSearchTable: 'public_room_search_table'
} as const;
